import React, {memo, useState} from "react";
import moment from "moment";
import ScrollArea from "react-scrollbar";
import Form from "../../components/Form";
import EventFields from "./components/EventFields";
import {eventFormConfig} from "./config";


const Step4 = ({selectSessions, setSelectSessions, setStep}) => {
    const [errors, setErrors] = useState([]);

    const handleTransformValues = values => ({
        phone: values.phone,
        comment: values.comment,
        service_session_ids: selectSessions.map(session => session.id)
    });

    const handleSuccess = data => {
        if(data.result) {
            setSelectSessions([]);
            setStep(5);
        } else {
            setSelectSessions([]);

            setErrors([selectSessions.length > 1 ?
                'Некоторые из выбранных Вами сеансов уже заняты. Попробуйте выбрать другое время.' :
                'Выбранный Вами сеанс уже занят. Попробуйте выбрать другое время.'
            ]);
        }
    };

    const handleError = e => {
        if(e.isAxiosError && e.response) {
            if(e.response.data.errors) {
                setErrors(Object.keys(e.response.data.errors).map(key => `Ошибка ${key}: ${e.response.data.errors[key]}`));
            } else {
                setErrors([`Ошибка ${e.response.status}: ${e.response.statusText}`]);
            }
        } else {
            setErrors(['Что-то пошло не так...']);
        }
    };

    return (
        <div className="registration-for-service__step-4 step-4">
            {!errors.length ?
                <ScrollArea
                    className="step-4__wrap-scroll"
                    contentClassName="step-4__scroll"
                    verticalScrollbarStyle={{borderRadius: 6, width: 6, backgroundColor: '#aaa'}}
                    verticalContainerStyle={{borderRadius: 8, width: 8}}
                    horizontal={false}
                    smoothScrolling={true}
                >
                    <>
                        <h4 className="step-4__title">
                            {selectSessions.map(session =>
                                <p key={session.id}>
                                    {`Сеанс ${moment(session.start).format('DD.MM.YYYY')} ${moment(session.start).format('HH:mm')} - ${moment(session.end).format('HH:mm')}`}
                                </p>
                            )}
                        </h4>
                        <Form
                            {...eventFormConfig}
                            transformValues={handleTransformValues}
                            onSuccess={handleSuccess}
                            onError={handleError}
                            className="step-4__form"
                            resetForm
                        >
                            <EventFields/>
                        </Form>
                    </>
                </ScrollArea> :
                <div className="registration-for-service__errors">
                    {errors.map((error, i) =>
                        <p key={`error-${i}`}>{error}</p>
                    )}
                </div>
            }
        </div>
    )
};

export default memo(Step4);